import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthProvider";
import { getAppUserActs } from "api/appUsers"; // Need to ensure we have a way to get *assignments* too
// If getAppUserActs returns acts, we can extract items, but ideally we want "Active Assignments"
import { apiGet } from "lib/apiClient"; // Direct call or add a new api method

// Helper for active assignments
async function getMyActiveAssignments(appUserId) {
    // Use the existing endpoint but filter or use the app-users assignments endpoint
    // GET /app-users/{id}/assignments/
    const { data, error } = await apiGet(`/app-users/${appUserId}/assignments/`);
    if (error) throw new Error(error);
    return data || [];
}

export default function EmployeeDashboard() {
    const { user } = useAuth();
    const [activeItems, setActiveItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (user?.app_user?.id) {
            loadData();
        }
    }, [user]);

    const loadData = async () => {
        setLoading(true);
        try {
            const items = await getMyActiveAssignments(user.app_user.id);
            setActiveItems(items);
        } catch (e) {
            console.error("Failed to load assignments", e);
        } finally {
            setLoading(false);
        }
    };

    if (!user?.app_user) {
        return (
            <div className="text-center py-10">
                <h2 className="text-xl font-bold text-red-600">Xatolik</h2>
                <p>Siz xodim sifatida tizimga kirmagansiz.</p>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="bg-white dark:bg-slate-800 shadow rounded-lg p-6">
                <h2 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4">
                    Mening jihozlarim (Aktiv)
                </h2>

                {loading ? (
                    <div className="animate-pulse space-y-4">
                        {[1, 2, 3].map(i => <div key={i} className="h-16 bg-gray-100 dark:bg-slate-700 rounded-lg"></div>)}
                    </div>
                ) : activeItems.length === 0 ? (
                    <div className="text-center py-8 text-gray-500">
                        Sizga hozircha hech qanday jihoz biriktirilmagan.
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {activeItems.map((item) => (
                            <div
                                key={item.id}
                                className="border border-gray-200 dark:border-slate-700 rounded-lg p-4 hover:shadow-md transition-shadow bg-gray-50/50 dark:bg-slate-800/50"
                            >
                                <div className="flex justify-between items-start mb-2">
                                    <h3 className="font-semibold text-gray-900 dark:text-gray-100 line-clamp-2">
                                        {item.item_name}
                                    </h3>
                                    <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full dark:bg-green-900 dark:text-green-200">
                                        Aktiv
                                    </span>
                                </div>
                                <p className="text-sm text-gray-500 mb-1">SKU: {item.item_sku || '—'}</p>
                                <div className="flex justify-between items-center mt-3 pt-3 border-t border-gray-100 dark:border-slate-700">
                                    <span className="text-sm font-medium">
                                        {item.qty} {item.item_unit}
                                    </span>
                                    <span className="text-xs text-gray-400">
                                        {new Date(item.created_at).toLocaleDateString()}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
